import { Icon } from '@mui/material';
import MDButton from 'components/MDButton';
import React, { useEffect, useState } from 'react'
import { deleteComment, getComments, updateComment } from './../../api/routes';
import { toast } from "react-toastify";

export default function Comments() {
    const [comments, setComments] = useState()
    useEffect(() => {
        getComments((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setComments(data)
        })
    }, [])
    const deleteComments = (commentId) => {
        deleteComment(commentId, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return window.location.reload()
        })
    }
    const updateComments = (commentId, isShow) => {
        const data = {
            is_show: isShow
        }
        updateComment(commentId, data, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return window.location.reload()
        })
    }

    return (
        <div style={{ margin: '1rem 0' }}>
            {comments && comments.map(comment => <section key={comment.commentId} style={{ fontSize: '1rem', borderRadius: '8px', display: 'flex', flexDirection: 'column', minHeight: '60px', marginTop: '1rem', padding: '1rem', border: '1px solid #d2d6da' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <p style={{ color: '#00000099' }}>متن : <span style={{ color: '#010101' }}>{comment.text}</span></p>
                    <div>
                        {comment.isShow ? <MDButton onClick={() => updateComments(comment.commentId, false)} variant="text" color="error" >
                            عدم نمایش
                        </MDButton> : <MDButton onClick={() => updateComments(comment.commentId, true)} variant="text" color="success" >
                            نمایش
                        </MDButton>}
                        <MDButton onClick={() => deleteComments(comment.commentId)} variant="text" color="error" >
                            <Icon>delete</Icon>
                        </MDButton>
                    </div>
                </div>
                <p style={{ marginTop: '1rem' }}>⭐ {comment.rating}</p>
            </section>)}
        </div>
    )
}
